const BASE = process.env.REACT_APP_BACKEND_URL;
const SIZES = [["sm", 480], ["md", 960], ["lg", 1600]];

export const isMedia = (u) => typeof u === "string" && u.startsWith("/api/media/");

export function imgSrc(u, size = "md") {
  if (!u) return null;
  return isMedia(u) ? `${BASE}${u}/${size}` : u;
}

export function imgSrcSet(u) {
  if (!isMedia(u)) return undefined;
  return SIZES.map(([k, w]) => `${BASE}${u}/${k} ${w}w`).join(", ");
}
